import { Component } from '@angular/core';
import { LoadingController, NavController, NavParams } from 'ionic-angular';
import { DishServices } from "../../services";
import { Globals } from "../../../../globals";
import { IngredientsServices } from '../../../ingredients/services';
import { HttpClient } from '@angular/common/http';
import { getCurrencySymbol } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';

/**
 * Generated class for the DishViewListPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-dish-foodcost-persons',
  templateUrl: 'dish-foodcost-persons.html',
})
export class DishFoodcostPersonsPage {

  dish_uid: any;
  dish_name: string;
  persons: number = 1;
  foodcost: any;
  foodcost_parts: any;
  foodcost_static: any;
  foodcost_per_persons: any = [];
  total_cost: number = 0;
  total_ration: number = 0;
  dish: any;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public dishServices: DishServices,
    public loadingCtrl: LoadingController,
    public globals: Globals,
    public ingredientsServices: IngredientsServices,
    public http: HttpClient,
    public translate: TranslateService) {

    this.dish_uid = this.navParams.get('dish_uid');
    this.dish_name = this.navParams.get('dish_name');
    this.foodcost = this.navParams.get('foodcost');
    this.foodcost_parts = this.navParams.get('foodcost_parts');
    this.foodcost_static = this.navParams.get('foodcost_static');
    this.dish = this.navParams.get('dish');
  }

  ionViewWillEnter() {
    this.foodcostPerOnePortion();
  }

  changePersons() {
    this.foodcostPerXPortions();
  }

  foodcost_one_portion = [];
  foodcostPerXPortions() {
    //Reseteamos los valores
    this.foodcost_per_persons = [];
    this.total_cost = 0;

    //Hacemos un for del array que contiene los valores de una porcion
    for (let item of this.foodcost_one_portion) {

      //Calculamos los valores
      let name_static = item.name_static;
      let quantity = item.quantity * this.persons;
      let waste = item.waste;
      //Calculo de la merma
      let quantity_gross = this.ingredientsServices.calculateWaste(waste, quantity);
      let pricetotal_static = this.ingredientsServices.calculatePrice(item.price_static, quantity_gross, item.measurement_static);

      this.total_cost += pricetotal_static;
      //Llenamos el array con los valores
      let _array = {
        'name_static': name_static,
        'quantity': quantity,
        'waste': waste,
        'quantity_gross': quantity_gross,
        'pricetotal_static': pricetotal_static,
        'measurement_static': item.measurement_static,
        'price_static': item.price_static,
        'provider_static': item.provider_static,
        'uid': item.uid,
        'total_cost': this.total_cost,
        'foodcost_parts': this.foodcost_parts,
        'foodcost_static': this.foodcost_static
      };
      //Hacemos push a l'array que mostraremos en la table
      this.foodcost_per_persons.push(_array);
    }
  }

  foodcostPerOnePortion() {
    //Hacemos un for para poder calcular el foodcost de una sola porcion
    for (let item of this.foodcost) {
      //Calculamos los valores
      let name_static = item.name_static;
      let quantity = item.quantity / this.foodcost_parts;
      let waste = item.waste;
      //Calculo de la merma
      let quantity_gross = this.ingredientsServices.calculateWaste(waste, quantity);
      let pricetotal_static = this.ingredientsServices.calculatePrice(item.price_static, quantity_gross, item.measurement_static);

      this.total_cost += pricetotal_static;
      //Llenamos el array con los valores
      let _array = {
        'name_static': name_static,
        'quantity': quantity,
        'waste': waste,
        'quantity_gross': quantity_gross,
        'pricetotal_static': pricetotal_static,
        'measurement_static': item.measurement_static,
        'price_static': item.price_static,
        'provider_static': item.provider_static,
        'uid': item.uid,
        'total_cost': this.total_cost,
        'foodcost_parts': this.foodcost_parts,
        'foodcost_static': this.foodcost_static

      };
      //Hacemos push a l'array que mostraremos en la table
      this.foodcost_per_persons.push(_array);
    }
    //Creamos una array para guardar los valores de una porcion
    this.foodcost_one_portion = this.foodcost_per_persons;
  }

  print() {
    this.globals.GAtrackView('Dish', 'Dish - Foodcost persons - Print', this.globals.restaurant.email, 'View', 'Print foodcost persons', 'Dish', this.dish_name);

    let loadingPopup = this.loadingCtrl.create({
      spinner: 'crescent',
      content: ''
    });
    loadingPopup.present();
    //Format object foodcost_per_persons for POST send
    var foodcost_send = this.foodcost_per_persons;

    var _currency = getCurrencySymbol(this.globals.user_currency, 'narrow', 'es');
    var currency = _currency;

    this.http.post(this.globals.api_path + 'dish/print_foodcost',
      {
        foodcost: foodcost_send,
        currency: currency,
        dish_name: this.dish_name,
        persons: this.persons,
      }, {})
      .subscribe(res => {
        if (this.globals.so_mobile) {
          window.location.assign(String(res['file']));
        } else {
          window.open(String(res['file']), '_blank');
        }
        loadingPopup.dismiss();
      }, error => {
        loadingPopup.dismiss();
      });
  }
}



// WEBPACK FOOTER //
// ./src/pages/dish/dish-view/dish-foodcost-persons/dish-foodcost-persons.ts